import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'vendor_name', label: 'Vendor' },
  { key: 'po_count', label: 'Orders', align: 'right' },
  { key: 'total_po_value', label: 'Total Order Value', align: 'right', type: 'money' },
  { key: 'on_time_delivery_rate', label: 'On-Time Delivery', align: 'right', type: 'percent' },
  { key: 'invoice_count', label: 'Invoices', align: 'right' },
  { key: 'discrepancy_rate', label: 'Discrepancy Rate', align: 'right', type: 'percent' },
];

export function VendorPerformanceReport() {
  return (
    <ReportView
      title="Vendor Performance"
      description="Purchase orders grouped by vendor: on-time delivery (first goods receipt vs the PO delivery date) and invoice discrepancy rate."
      endpoint="/reports/procurement/vendor-performance"
      columns={COLUMNS}
      filters={['dateRange']}
      defaultSort="total_po_value"
      xlsx
    />
  );
}
